<template>
    <div>
        <h2 class="h2">{{ t('title') }}</h2>
        <p>{{ t('text1') }}</p>
        <p>{{ t('text2') }}</p>
        <DSInput
            v-model="order.data.value.contact"
            :label="t('contactPerson')"
            :help-text="t('required')"
            :error="order.errors.value.contact"
        />
        <DSInput
            v-model="order.data.value.phone"
            :label="t('phone')"
            :help-text="t('required')"
            :error="order.errors.value.phone"
        />
        <DSInput
            v-model="order.data.value.email"
            :label="t('email')"
            :help-text="t('required')"
            :error="order.errors.value.email"
        />
        <p class="contact-method">{{ t('contactMethod') }}</p>
        <DSSwitches
            v-model="order.data.value.contactMethod"
            type="radio"
            :options="[
                { value: 'phone', label: t('viaPhone') },
                { value: 'email', label: t('viaEmail') },
            ]"
        />
    </div>
</template>
<script setup>
import { inject, useI18n } from '#imports';

const order = inject('order');

defineOptions({
    inheritAttrs: false,
});

defineProps({
    stepTitle: {
        type: String,
        required: false,
        default: '',
    },
});

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            title: 'Tilaajan yhteystiedot',
            text1: 'Maksu tapahtuu paikan päällä.',
            text2: 'Asema on yhteydessä, kun tilaus on käsitelty ja vahvistaa vielä tilauksen',
            contactPerson: 'Yhteyshenkilö',
            address: 'Osoite',
            phone: 'Puhelinnumero',
            email: 'Sähköposti',
            contactMethod: 'Haluan yhteydenoton ensisijaisesti (voi valita vain toisen)',
            viaPhone: 'Puhelimella',
            viaEmail: 'Sähköpostitse',
        },
        'en-EU': {
            title: 'Tilaajan yhteystiedot',
            text1: 'Maksu tapahtuu paikan päällä.',
            text2: 'Asema on yhteydessä, kun tilaus on käsitelty ja vahvistaa vielä tilauksen',
            contactPerson: 'Contact person',
            address: 'Address',
            phone: 'Phonenumber',
            email: 'Email',
            contactMethod: 'Haluan yhteydenoton ensisijaisesti (voi valita vain toisen)',
            viaPhone: 'Puhelimella',
            viaEmail: 'Sähköpostitse',
        },
    },
});
</script>
<style scoped>
.ds-input {
  margin-bottom: 0;
}

.contact-method {
  margin-top: 1.5rem;
}

.message {
  font-size: 0.75rem;
  color: var(--color-base-grey-600);
  margin-bottom: 1rem;
}
</style>
